import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions, combineActions } from 'redux-actions';
import { reduxKey } from './constants';
import { initializeNetworkBar, markChannelAsRead, updateNetworkBarSection, setNetworkBarSection } from './actions';
import { generateMainNavigation, getDefaultMainNavigation } from './helpers';
const handler = handleActions({
    [initializeNetworkBar.toString()]: (state, { payload: { mainNavNewContent } })=>_object_spread_props(_object_spread({}, state), {
            mainNavigation: generateMainNavigation(mainNavNewContent),
            isInitialized: true
        }),
    [markChannelAsRead.toString()]: (state, { payload: { channel } })=>{
        // groups are handled by saga, this takes care of the main nav
        const navItem = state.mainNavigation.find((n)=>n.key === channel);
        if (navItem === null || navItem === void 0 ? void 0 : navItem.hasNewContent) {
            return _object_spread_props(_object_spread({}, state), {
                mainNavigation: state.mainNavigation.map((n)=>n === navItem ? _object_spread_props(_object_spread({}, n), {
                        hasNewContent: false
                    }) : n)
            });
        }
        return state;
    },
    [combineActions(updateNetworkBarSection, setNetworkBarSection).toString()]: (state, { payload: { section, isFoldedNow } })=>state.sections[section].isFolded === isFoldedNow ? state : _object_spread_props(_object_spread({}, state), {
            sections: _object_spread_props(_object_spread({}, state.sections), {
                [section]: {
                    isFolded: isFoldedNow
                }
            })
        })
}, {
    isInitialized: false,
    mainNavigation: getDefaultMainNavigation(),
    sections: {
        watched_groups: {
            isFolded: false
        },
        recommended_groups: {
            isFolded: false
        }
    }
});
export default {
    [reduxKey]: handler
};
